import { StoreType } from '@tock/shared/utils/connect';

export const toastSelector = (state: StoreType) => state.toast;
